import { defineStore } from 'pinia'
import { onMounted, ref } from 'vue'
import useChatStore from './chatStore'

const useThemeStore = defineStore('newans-theme', () => {
  /**
   * 主题列表
   */
  const appThemeList: string[] = [
    '#2d8cf0',
    '#0960bd',
    '#0084f4',
    '#009688',
    '#536dfe',
    '#ff5c93',
    '#ee4f12',
    '#0096c7',
    '#9c27b0',
    '#ff9800',
    '#FF3D68',
    '#00C1D4',
    '#71EFA3',
    '#171010',
    '#78DEC7',
    '#152634FF',
    '#FB9300',
    '#FC5404',
  ]

  /**
   * 是否使用暗色主题
   */
  const useDarkTmeme = ref(false)

  /**
   * 主题颜色
   */
  const appTheme = ref('#171010')

  /**
   * 当前窗口宽度
   */
  const currentWindowWidth = ref(0)

  /**
   * 设置当前窗口宽度
   * @param width 窗口宽度
   */
  const setCurrentWindowWidth = (width: number) => {
    currentWindowWidth.value = width
  }

  /**
   * 初始化当前窗口宽度
   */
  onMounted(() => {
    setCurrentWindowWidth(window.innerWidth)
  })

  /**
   * 侧边栏折叠状态
   */
  const sideCollapsed = ref(false)

  /**
   * 设置侧边栏折叠状态
   * @param collapsed 折叠状态
   */
  const setSideCollapsed = (collapsed: boolean) => {
    sideCollapsed.value = collapsed
  }

  /**
   * 监听窗口宽度变化
   */
  window.addEventListener('resize', () => {
    setCurrentWindowWidth(window.innerWidth)
    sideCollapsed.value = window.innerWidth > 1200 && !useChatStore().showMorePanel ? false : true
  })

  return {
    currentWindowWidth,
    sideCollapsed,
    setSideCollapsed,
    setCurrentWindowWidth,
    useDarkTmeme,
    appThemeList,
    appTheme,
  }
})

export default useThemeStore
